import { CubejsApi, Query } from '@cubejs-client/core';
import { QueryBuilder, QueryBuilderRenderProps } from '@cubejs-client/react';
import React from 'react';
import Loader from 'app/components/general/Loader';


export interface ICubeJsGraphProps {
  cubejsApi: CubejsApi;
  timePeriod: string | string[];
  competition?: string;
  resultSet?: any;
}

interface ICubeJsGraphState {
  error?: string;
  changed: boolean;
}

export abstract class CubeJsGraphBase extends React.Component<ICubeJsGraphProps, ICubeJsGraphState> {
  graphType: string;

  abstract graphName(): string

  abstract query(): Query

  abstract queryRender(renderProps: QueryBuilderRenderProps): React.ReactElement

  constructor(props) {
    super(props);
    this.state = {};
  }

  static getSingleNumberFromRenderProps(props: QueryBuilderRenderProps) {
    const { resultSet } = props;
    return resultSet
      .seriesNames()
      .map((s) => resultSet.totalRow()[s.key]);
  }

  static getDerivedStateFromError(error) {
    return { error: error.toString() };
  }

  componentDidCatch(error, errorInfo) {
    if (!this.state.changed) {
      this.setState({ error, changed: true });
    }
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return (
        <p>
          <em>
            Error
            {' '}
            {this.state.error}
          </em>
        </p>
      );
    }

    return (
      <>
        {this.graphType !== 'large' && (
          <div className="graph-name">
            {this.graphName()}
          </div>
        )}
        {this.graphType === 'large' && (
          <div className="graph-name">
            <h3>
              {this.graphName()}
            </h3>
          </div>
        )}
        <QueryBuilder
          query={this.query()}
          cubejsApi={this.props.cubejsApi}
          render={(props) => {
            const { resultSet } = props;

            if (props.error) {
              return (
                <span className="d-inline-block w-100 text-center">
                  No data
                </span>
              );
            }

            if (!resultSet) {
              return (
                <div className="graph-loader">
                  <Loader isActive color="grey" />
                </div>
              );
            }
            return this.queryRender(props);
          }}
        />
      </>
    );
  }
}
